export default __webpack_public_path__ + "static/media/BFS_2022_RLDynamicRisk.c5c07ac2.pdf";